import * as React from 'react';
import * as moment  from "moment-timezone";
import {MainStageData} from "data/MainStageData";

import './MainStageEventPage.pcss';
import {MainStageEventScheduleItem} from "components/mainstage/MainStageEventScheduleItem";
import {MainStageQuestionWidget} from "components/mainstage/MainStageQuestionWidget";
import {observer} from "mobx-react";
import {IPageWrapperWithNav_Props, PageWrapperWithNav} from "components/widgets/PageWrapperWithNav";
import {MainStageStatusMessage} from "components/mainstage/MainStageStatusMessage";

@observer
export class MainStageEventPage extends React.Component<IPageWrapperWithNav_Props> {


  render() {
    return (
      <PageWrapperWithNav {...this.props} className={"mainstage"}>
          <div className="pwn-content" >
            {!MainStageData.liveMainStageEvent && MainStageData.nextMainStageEvent &&
            <div className="next" style={{backgroundImage:`url("${MainStageData.nextMainStageEvent.backgroundImage}")`}}>
              <div className={"banner"}>
                <h3 className={'level3'}>UP NEXT</h3>
                <h2 className={'level2'}>{MainStageData.nextMainStageEvent.title}</h2>
                <h4 className={'level4'}>{`${moment(MainStageData.nextMainStageEvent.presentationStartTS).tz(moment.tz.guess()).format('h:mm')}-${moment(MainStageData.nextMainStageEvent.presentationEndTS).tz(moment.tz.guess()).format('h:mm')} • Live Session`}</h4>
                <h4 className={'level4'}>{`${moment(MainStageData.nextMainStageEvent.qaStartTS).tz(moment.tz.guess()).format('h:mm')}-${moment(MainStageData.nextMainStageEvent.qaEndTS).tz(moment.tz.guess()).format('h:mm')} • Live Q&A`}</h4>
              </div>
            </div>
            }

            {MainStageData.liveMainStageEvent &&
              <>
                {MainStageData.liveMainStageEvent.isZoom?
                  <div className="next zoomLink">
                    <div className={"banner"}>
                      <h3 className={'level3'}>Zoom alternate link</h3>
                      <p>Our primary engineering facility is experiencing technical difficulties. Please use this link to participate using Zoom.</p>
                      <h4><a
                        href={MainStageData.liveMainStageEvent.liveStreamLink}
                        target={"_blank"}
                        aria-label={`${MainStageData.liveMainStageEvent.title} on Zoom, opens new tab`}
                      >{MainStageData.liveMainStageEvent.title} on Zoom</a></h4>
                    </div>
                  </div>
                  :
                  <div className="vimeoBlock">
                    <iframe
                      src={MainStageData.liveMainStageEvent.liveStreamLink}
                      title={MainStageData.liveMainStageEvent.title}
                      frameBorder="0"
                      allow="autoplay; fullscreen"
                      allowFullScreen
                      style={{
                        position:'absolute',
                        top:0,
                        left:0,
                        width:'100%',
                        height:'360px',
                      }}
                      ></iframe>
                  </div>
                }
              </>
            }

            {!MainStageData.nextMainStageEvent && !MainStageData.liveMainStageEvent &&
            <div className="next" style={{backgroundImage:`url(/res_sys/sessions/MainstageConcluded_bg.jpg)`}}>
              <div className={"banner"}>
                <h2>Mainstage Concluded</h2>
                <p className="mainstage-concluded-description">Check out the Feed for the full recordings and quizzes.</p>
              </div>
            </div>
            }
          </div>


        {MainStageData.liveMainStageEvent && <div className={'reloadTheBroEast'}>If the Mainstage is live and you don't see the video, try reloading your browser.</div>}

          <div className={"mainstage-under-content"}>

            <MainStageStatusMessage />

            <MainStageQuestionWidget />

            <div className={"mainstage-schedule block"}>
              <h2>Main Stage Schedule</h2>
              <div role={'list'} aria-label={'Sessions on the main stage'}>
                {MainStageData.mainStageEvents.map((event)=><MainStageEventScheduleItem event={event} key={event._id} />)}
              </div>
            </div>

          </div>
      </PageWrapperWithNav>
    );
  }
}

